import { AIStatusColors, DEFAULT_STATUS_MESSAGE } from './ai.constants';
import { IAIState } from './ai.props';

const initialState: IAIState = {
  isAIAutoMode: true, // Indicates whether AI order has been going smoothly or intercepted
  isAIEscalation: false,
  isAIEscalatedOnCarEnter: false, // Triggered AI escalation for faster adoption of brand menu
  aiStatus: {
    status: AIStatusColors.green,
    message: DEFAULT_STATUS_MESSAGE,
  },
  aiEscalationReason: '',
};

export { initialState };
